import { User } from './User';
import { LanguageCode } from '../Utils/Language';
import { Tag } from './Tag';

// NOTE: the fields marked `| null` below map to nullable columns and really do arrive as null.
// This project does not enable `strictNullChecks` (see tsconfig.json) and never runs `tsc`, so
// the compiler will NOT enforce these annotations — guard at runtime, not just in the types.
export type Copilot =
  { id: number
  , userId: number
  , createdAt: string
  , active: boolean
  , validForPayment: boolean
  , isOpenToWork: boolean
  , bio: string | null
  , headline: string | null
  , location: string | null
  , preferredName: string | null
  , pronouns: string | null
  , hourlyRateCents: number | null
  , tags: Tag[]
  , workStyles: CopilotWorkStyle[]
  , imageUrl: string
  , favoritedByCurrentAgent: boolean
  , averageRating?: number
  , numRatings: number
  , jobsInProgress: number
  , jobsCompleted: number
  , lifetimeEarningsCents: number
  , languageCodes: LanguageCode[]
  , lastSeenAt: string | null
  , profileUrl: string
  , isTernCertified: boolean
  , sortScore: number
  , user?: User
  }

export type CopilotFunFact =
  { question: string
  , answer: string
  , emoji: string
  }

export function copilotProfileUrl(copilot: Copilot) {
  return `/agent/copilots/profile/${copilot.id}`
}

export function copilotMessagesUrl(copilot: Copilot) {
  if (copilot) {
    return `/agent/messages?other_user_id=${copilot.userId}`
  } else {
    return "/agent/messages"
  }
}

export type CopilotWorkStyle =
  { id: number
  , name: string
  }

export type CopilotPortfolioItem =
  { id: number
  , title: string
  , fileUrl: string
  , isVisible: boolean
  }

export type CopilotEducationLine =
  { id: number
  , institution: string
  , description?: string
  , startMonth?: number
  , startYear?: number
  , endMonth?: number
  , endYear?: number
  }

export type CopilotEmploymentLine =
  { id: number
  , company: string
  , title: string
  , employmentType?: EmploymentType
  , startMonth?: number
  , startYear?: number
  , endMonth?: number
  , endYear?: number
  }

export enum EmploymentType
  { FullTime = 'full-time'
  , PartTime = 'part-time'
  , SelfEmployed = 'self-employed'
  , Contract = 'contract'
  }
